<style media="screen">
</style>

<template>
    <div>
        <!-- Navigation -->
        <main-menu />

        <!-- Header -->
        <main-header />

        <!-- about -->
        <about />

        <!-- services -->
        <services />

        <!-- coverage -->
        <coverage />

        <!-- clients -->
        <clients />

        <!-- portfolio -->
        <!-- <portfolio /> -->

        <!-- work -->
        <work />

        <contact />

    </div>
</template>

<script>
import MainMenu from '../../components/menu/MainMenu.vue'
import MainHeader from '../../components/header/MainHeader.vue'
import About from '../../components/about/About.vue'
import Services from '../../components/services/Services.vue'
import Coverage from '../../components/coverage/Coverage.vue'
import Clients from '../../components/clients/Clients.vue'
import Portfolio from '../../components/portfolio/Portfolio.vue'
import Work from '../../components/work/Work.vue'
import Contact from '../../components/contact/Contact.vue'

export default {
    name: 'app',
    components: {
        MainMenu,
        MainHeader,
        Contact,
        About,
        Services,
        Coverage,
        Clients,
        Portfolio,
        Work,
    },
    created () {

    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/vue/apps/App/App.vue